import React from 'react';
import YoutubeEmbed from '../components/YoutubeEmbed';
import { Zoom } from "react-awesome-reveal";


const MyWorks: React.FC = () => {

    return <section id='myworks' className='section' style={{ backgroundColor: "var(--grey3)" }}>
        <h2 className='title2 center'>Some of my works</h2>
        <Zoom triggerOnce={true}>
            <div className='container row' style={{ gap: 50 }}>
                <YoutubeEmbed embedId="nygK4ZNRAlE" />
                <YoutubeEmbed embedId="8cNmWx0Ejhk" />
                <YoutubeEmbed embedId="6f0EIlUCUhc" />
                <YoutubeEmbed embedId="vv5VL-W8Qgg" />
                <YoutubeEmbed embedId="MtaSOnFYXxw" />
                <YoutubeEmbed embedId="28ZOqXfpn0s" />
            </div>
        </Zoom>
    </section>
}

export default MyWorks